import React, { useEffect } from "react";
import MoneyHero from "./common/hero";
import Insurance from "./common/insurance";
import LegacyPlanning from "./common/legacy";
import { useGetMoneyPageDataQuery } from "../../store/api/moneyApi";
import Cleartax from "./common/cleartax";
import { useAppSelector } from "../../hooks/store-hooks";
import { MODAL_NAME } from "../../constants";
import BecomeMember from "../common/membership";

const header = {
  type: "Protect",
  title: "Protect your loved ones",
  button: "Book Your FREE Call",
  bgImage: "/assets/money/protect-header-bg.webp",
  image: "/assets/money/protect-header.webp",
  redirectUrl: "https://pillowinsurance.com/?advisory=true",
  theme: "#63c6ff",
  textColor: "black",
  imageClass: "w-[312px] h-[261px]",
};

const ProtectComponent = () => {
  const { data, refetch } = useGetMoneyPageDataQuery("protect");
  const { modalName } = useAppSelector((state) => state.modal);
  useEffect(() => {
    refetch();
  }, []);
  return (
    <div className="flex flex-col gap-8 max-w-[1000px]">
      <MoneyHero
        data={{
          ...header,
          redirectUrl: data?.data?.banner_button?.redirect_url,
        }}
      />
      <Insurance redirectUrl={data?.data?.banner_button?.redirect_url} />
      <div className="flex flex-row gap-8">
        <div className="flex-1">
          <Cleartax />
        </div>
        <div className="flex-1">
          <LegacyPlanning
            redirectUrl={data?.data?.legacy_planning?.redirect_url}
          />
        </div>
      </div>
      {modalName === MODAL_NAME.BECOME_MEMBER && <BecomeMember />}
    </div>
  );
};

export default ProtectComponent;
